import React, { useState } from "react";

import Bluelagoon from "../Bluelagoon.js";

export function useBluelagoon({
    method,
    setIsLoading = true,
    resetResponse = true,
}) {
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setLoading] = useState(false);

    const call = React.useCallback(
        (params) => {
            setError(null);
            if (setIsLoading) setLoading(true);
            if (resetResponse) setResponse(null);
            return new Promise((resolve, reject) => {
                Bluelagoon[method](params)
                    .then((response) => {
                        setResponse(response?.data);
                        setLoading(false);
                        setError(null);
                        resolve(response?.data);
                    })
                    .catch((error) => {
                        // Preserve the axios error when there's no HTTP response
                        // (e.g. network failure), so callers can read error.message
                        // instead of receiving `undefined`.
                        const rejection = error?.response?.data ?? error;
                        setError(error?.response?.data);
                        setLoading(false);
                        reject(rejection);
                    });
            });
        },
        [method, setIsLoading, resetResponse]
    );

    return { call, response, error, isLoading };
}
